module.exports = __webpack_public_path__ + "static/media/password.f774546c.png";